import StopCircle from "@mui/icons-material/StopCircle";
import ArrowUpward from "@mui/icons-material/ArrowUpward";
import { Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";

import { Translator } from "@/components/i18n";
import { useChatData } from "@/client/useChatData";
import { useChatMessages } from "@/client/useChatMessages";
import { useChatInteract } from "@/client/useChatInteract";

interface SubmitButtonProps {
  disabled?: boolean;
  onSubmit: () => void;
}

const SubmitButton = ({ disabled, onSubmit }: SubmitButtonProps) => {
  const { loading } = useChatData();
  const { firstInteraction } = useChatMessages();
  const { stopTask } = useChatInteract();

  const handleClick = () => {
    stopTask();
  };

  return (
    <Box
      sx={{
        color: "text.secondary",
        mb: 0.4,
      }}
    >
      {loading && firstInteraction ? (
        <Tooltip
          title={
            <Translator path="components.organisms.chat.inputBox.SubmitButton.stopTask" />
          }
        >
          <IconButton id="stop-button" onClick={handleClick}>
            <StopCircle />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip
          title={
            <Translator path="components.organisms.chat.inputBox.SubmitButton.sendMessage" />
          }
        >
          <IconButton
            disabled={disabled}
            onClick={onSubmit}
            sx={{
              backgroundColor: disabled ? "text.disabled" : "primary.main",
              color: disabled ? "text.disabled" : "secondary.contrastText",
              "&:hover": {
                backgroundColor: disabled ? "text.disabled" : "primary.dark",
              },
              width: 30,
              height: 30,
            }}
          >
            <ArrowUpward fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export { SubmitButton };
